import React, { useEffect, useRef, useState, createRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  SLowcodeList,
  SIDRender,
  SDrawer
} from 'shj-components'
import config from './config';
import dayjs from 'dayjs'
import {
  getTenantId,
} from '@/common/utils'
import { receiptApplyFindResponseListByPageForMainPage, httpDictServTenant, findQuotationTypes, 
   getEnum, findCanPaymentApplyResponseForHandle, paymentApplyAddAndVerfiyBatch } from '@/services/fmsServices'
import { AddOrEditForm } from './components'
import { CollectionForm } from '../receivableList/components/collection'
import { Modal, Button, message } from 'antd'
import styles from '../receivableList/index.module.less'
export default function PaymentServiceManage() {
  const history = useNavigate();
  const tenantId = getTenantId()
  const [openModal, setModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [editData, setEditData] = useState(null);
  const [openType, setOpenType] = useState(false);
  const [openCollectModal, setOpenCollectModal] = useState(false);
  const [recordData, setRecordData] = useState(null);
  const [collectData, setCollectData] = useState(null);
  const [collectList, setCollectList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lineLoading, setLineLoading] = useState(false);
  const [transResponseList, setTransResponseList] = useState([] as any);
  const listRef = useRef<any>();
  const childRef = createRef<any>()
  const collectRef = createRef<any>()
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        if(query.notEqualVerifyState === 'noVerifyStateNotEffective'){
          delete query.notEqualVerifyState 
        }
        if(query.receiptType){
          query.receiptTypeList = [query.receiptType]
        }
        if (query.receivableDate) {
          query.receivableDateStart = dayjs(query.receivableDate[0]).format('YYYY-MM-DD 00:00:00')
          query.receivableDateEnd = dayjs(query.receivableDate[1]).format('YYYY-MM-DD 23:59:59')
        }
        receiptApplyFindResponseListByPageForMainPage(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };
  // 查看
  const onInfo = (record) => {
    setEditData(record)
    setReadOnly(true)
    setModal(true)
  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  // 收款方式
  const onMergeReceipts = (record: any) => {
    if(record?.selectedRows?.length){
      const selectedRowsList = record.selectedRows.map(item => ({
        ...item,
        receivableDate: dayjs(item.receivableDate).format('YYYY-MM-DD HH:mm:ss')
      }));
      setCollectList(selectedRowsList)
    }else{
      setCollectList([{...record, receivableDate: dayjs(record.receivableDate).format('YYYY-MM-DD HH:mm:ss')}] as any || [])
    }
    setOpenType(true)
    setRecordData(record)
    // let typeModal = Modal.info({
    //   title: '收款方式选择',
    //   icon: null,
    //   closable: true,
    //   content: (
    //     <div style={{ padding: '30px 0' }}>
    //       <Button loading={QRloading} onClick={()=>{onQRReceiptsConfirm(record, typeModal)}}>生成收款二维码</Button>
    //       <Button style={{ marginLeft: 20 }} onClick={()=>{typeModal.destroy();onReceiptsConfirm(record)}}>线下收款</Button>
    //     </div>
    //   ),
    //   footer: null,
    // });
  }
  const onReceiptsConfirm = (record) => {
    setLineLoading(true)
    const list = record?.selectedRows?.length ? record.selectedRows.map(m => m.id) : [record.id];
    findCanPaymentApplyResponseForHandle({
      orderAccountId: '',
      receiptApplyIdList: list
    }).then((res) => {
      setOpenType(false)
      setLineLoading(false)
      setTransResponseList(res.transResponseList)
      setOpenCollectModal(true),
      setCollectData(null)
    }).catch(err=>{
      setLineLoading(false)
    })
  }
  const onConfirmCollect = () => {
    collectRef.current?.validateFields().then(async (values: any) => {
      const formatDate = (date: any) => date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
      values.receivedDate = formatDate(values.receivedDate);
      values.accountingDate = formatDate(values.accountingDate);
      // values.receivedClickDate = formatDate(values.receivedClickDate);
      values.customerReceiptFlag = values.customerReceiptFlag ? '1' : '0';
      values.creditFlag = values.creditFlag ? '1' : '0';
      values.orderAccountId = ''
      let list: any = collectRef.current?.getValue()?.details;
      // 根据 receiptType 合并相同的项
      const mergedList = list.reduce((acc: any, item: any) => {
        const existing = acc.find((i: any) => i.receiptType === item.receiptType);
        if (existing) {
          existing.paymentApplyReceiptApplyList.push({
            needVerifiedAmount: item.needVerifiedAmount,
            receiptApplyId: item.id,
            receiptType: item.receiptType,
          }); // 合并相同 receiptType 的项
        } else {
          acc.push({ receiptType: item.receiptType, paymentApplyReceiptApplyList: [{
            needVerifiedAmount: item.needVerifiedAmount,
            receiptApplyId: item.id,
            receiptType: item.receiptType,
          }]});
        }
        return acc;
      }, []);
      const updatedMergedList = mergedList.map((item) => {
        // 新增 transactionType 参数
        const updatedPaymentApplyReceiptApplyList = item.paymentApplyReceiptApplyList.map(paymentItem => {
          // 匹配 transResponseList 中的 receiptApplyResponseList
          const matchingResponse = transResponseList.find(responseItem => 
            responseItem.receiptApplyResponseList.some(response => response.receiptApplyId === paymentItem.receiptApplyId)
          );
          return {
            ...paymentItem,
            transactionType: matchingResponse ? matchingResponse.transactionType : undefined, // 添加 transactionType
          };
        });
        return {
          ...values,
          receiptType: item.receiptType,
          transactionType: updatedPaymentApplyReceiptApplyList[0]?.transactionType, // 设置为第一个元素的 transactionType
          amount: updatedPaymentApplyReceiptApplyList.reduce((total, m) => total + ((m.needVerifiedAmount) || 0), 0),
          paymentApplyReceiptApplyList: updatedPaymentApplyReceiptApplyList
        };
      });
      // 输出新的数组
      if (collectRef.current?.getValue()?.isValid && collectRef.current?.getValue()?.errData === null) {
          setLoading(true)
          paymentApplyAddAndVerfiyBatch({list: updatedMergedList}).then((res)=>{
            message.success(res.message || '线下收款成功')
            reloadFn()
            setLoading(false)
            setOpenCollectModal(false)
          }).catch(err=>{
            setLoading(false)
          })
      } else {
        message.error('收款明细里面的收款金额未填写或有误');
      }
    })
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      let receiptTypeList = await httpDictServTenant({ parentKey: 'receiptType',enabled: 1 })
      let contractTypeList = await findQuotationTypes()
      const verifyStateList: any = await getEnum('com.shj.saas.plus.fms.enums.VerifyStateEnum')
      const payStateList: any = await getEnum('com.shj.saas.plus.fms.enums.RceiptApplyPayStateEnum')
      resolve({
        notEqualVerifyStateList: [{
          lable: '不显示',
          value: 'verifyStateNotEffective'
        },{
          lable: '显示',
          value: 'noVerifyStateNotEffective'
        }],
        receiptTypeList,
        contractTypeList,
        verifyStateList,
        payStateList
      },)
    })
  }
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {onMergeReceipts},
    customRender: {
      clueIdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onInfo(record)} copy={false}></SIDRender>
        )
      },
    },
  }
  return (
    <div className={styles.FmsDragTable}>
      <SLowcodeList config={config} ref={listRef} {...extension} 
        searchMode="group"
       />
       <SDrawer
        title={readOnly ? '查看应收' : '新增应收'}
        width="50%"
        isHideResetBtn={false}
        footer={[]}
        open={openModal}
        onClose={() => setModal(false)}
        destroyOnClose
        styles={{ header: { padding: '8px 15px' } }}
      >
        <AddOrEditForm ref={childRef} editData={editData} orderId={editData?.orderId} readOnly={readOnly} />
      </SDrawer>
      {/* 线下收款 */}
      <SDrawer
        title={'线下收款'}
        width="50%"
        okText="确认收款"
        isHideResetBtn={false}
        open={openCollectModal}
        onClose={() => setOpenCollectModal(false)}
        destroyOnClose
        loading={loading}
        onSubmit={onConfirmCollect}
        styles={{ header: { padding: '8px 15px' } }}
      >
        <CollectionForm ref={collectRef} collectData={collectData} collectList={collectList} financialOrgCode={''} />
      </SDrawer>
      <Modal
        title="收款方式选择"
        open={openType}
        footer={null}
        closable={true}
        onCancel={() => {setOpenType(false)}}
      >
         <div style={{ padding: '30px 0' }}>
          {/* 线上支付还没有好 */}
          {/* <Button loading={QRloading} onClick={()=>{onQRReceiptsConfirm(recordData)}}>生成收款二维码</Button> */}
          <Button loading={lineLoading} style={{ marginLeft: 20 }} onClick={()=>{onReceiptsConfirm(recordData)}}>线下收款</Button>
        </div>
      </Modal>
    </div>
  )
}
